import React, { useState, useEffect } from 'react';
import { database } from '../Firebase/Firebase';
import { ref, onValue, push, set } from 'firebase/database';
import "./Comment.scss"
import { useAuth } from '../context/AuthContext';

const Comments = ({ postId }) => {
    const {currentUser} = useAuth();
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');

  useEffect(() => {
    // Firebase database reference to the 'comments' node for the specific post
    const commentsRef = ref(database, `comments/${postId}`);

   
    // Listen for changes in the comments node and update the state
    const commentsListener = onValue(commentsRef, (snapshot) => {
        const commentsData = snapshot.val();
        if (commentsData) {
          // Convert the Firebase object of comments to an array
          const commentsArray = Object.values(commentsData);
          setComments(commentsArray);
        }
      });

     // Clean up the event listener when the component is unmounted
     return () => commentsListener();
  }, [postId]);

  const handleAddComment = () => {
    // Firebase database reference to the 'comments' node for the specific post
    const commentsRef = ref(database, `comments/${postId}`);

    // Generate a unique key for the new comment
    const newCommentKey = push(commentsRef).key;

    // Create the new comment object
    const newCommentObject = {
      id: newCommentKey,
      text: newComment,
      timestamp: Date.now(),
      userId:currentUser.uid,
    };

    // Save the new comment in the database
    set(ref(commentsRef, newCommentKey), newCommentObject);

    // Clear the input field after submitting the comment
    setNewComment('');
  };

  return (
    <div>
      <h4>Comments</h4>
      <ul>
        {comments.map((comment) => (
          <li key={comment.id}>{comment.text}</li>
        ))}
      </ul>
      <div className='commenting'>
        <textarea
          type="text"
          className='CommentryBox'
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
        />
        <button onClick={handleAddComment} className='Commentry-btn'>Post Comment</button>
      </div>
    </div>
  );
};

export default Comments;
